import { defineStore } from 'pinia';
import router from '@/router';
import { fetchAudiences, deleteAudience } from "@/services/ppApi";
import { useAccountStore } from '@/stores/account';

export const useAudiencesStore = defineStore('audiences', {
    state: () => {
        return {
            audiences: [],
            loading: false,
            error: null,
            found: 0
        }
    },
    actions: {
        resetAudiences() {
            this.$reset();
        },
        async getAudiences(forceFetch = false) {
            if(forceFetch || (this.audiences && this.audiences.length < 1)) {
                await this.fetchAudiences();
            }
            return this.audiences.length > 0 ? this.audiences : false;
        },
        async fetchAudiences() {
            this.loading = true;
            this.error = null;

            try {
                const params = {
                    account_id: useAccountStore().account.account_id,
                    add_stats: 0,
                };

                const response = await fetchAudiences(params);
                this.audiences = response.data.audiences;
                this.found = response.data.found;
            } catch (error) {
                this.audiences = [];
                this.found = 0;
                this.error = error;
            } finally {
                this.loading = false;
            }
        },
        openAudience(audience, mode = false) {
            if(mode) {
                switch (mode) {
                    case 'new':
                        router.push({ name: 'audienceSuspects', params: { id: audience.audience_id } });
                        break;
                    case 'prospects':
                        router.push({ name: 'audienceProspects', params: { id: audience.audience_id } });
                        break;
                    default:
                        router.push({ name: 'audienceCompanies', params: { id: audience.audience_id } });
                        break;
                }
            } else {
                router.push({ name: 'audience', params: { id: audience.audience_id } });
            }
        },
        async deleteAudience(audience) {
            try {
                const params = {
                    audience_id: audience.audience_id,
                    account_id: useAccountStore().account.account_id
                }

                await deleteAudience(params);
                this.audiences = this.audiences.filter(existingAudience => existingAudience.audience_id !== audience.audience_id);
                return true;
            } catch (error) {
                return false;
            }
        },
    }
});
